import React from 'react';
import { Button, Segment, Form, Grid } from 'semantic-ui-react';
import axios from 'axios';
import { toast } from 'react-toastify';


export default class AddNewCourse extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            course: '',
            courseErr: false,
            courses: {},
            student: JSON.parse(localStorage.getItem('student')),
            mob: JSON.parse(localStorage.getItem('mob')),
        };
        this.closeAddMode = this.closeAddMode.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.fetchCoursesOptions = this.fetchCoursesOptions.bind(this);
    }

    componentDidMount() {
        this.fetchCoursesOptions();
    }

    fetchCoursesOptions() {
        axios.get(`/course/not-passed-and-not-enrolled/${this.state.student.id}/`)
            .then(res => {
                this.setState({
                    courseOptions: res.data.map(el => ({
                        key: el.id,
                        value: el.id,
                        text: [
                            el.courseBasicName,
                            el.code,
                            el.studyProgramSemesterNames ? `Semestar: ${el.studyProgramSemesterNames}` : null,
                        ].filter(Boolean).join('   |   ')
                    }))
                });
            });
    }

    addCourse(course) {
        this.setState({ loader: true });
        let addCourseObj = {
            id: this.state.mob.id,
            courseStudyPrograms: [{ id: this.state.course }],
        };

        axios.put('student-study-program-mobility/add-courses/', { ...addCourseObj })
            .then(res => {
                toast('Dodavanje predmeta je uspješno izvršeno.');
                this.setState({ loader: false });
                this.props.getMobilityCourses();
                this.props.closeAddMode();
            })
            .catch(err => {
                toast('Došlo je do greške! Studentu nije dodan predmet.');
            });
    }

    closeAddMode() {
        this.props.closeAddMode();
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    render() {
        return (
            <div>
                <Segment.Group secondary>
                    <Segment secondary clearing>
                        <Form noValidate>
                            <Grid columns={1} centered className="stackable">
                                <Grid.Row stretched>
                                    <Grid.Column>
                                        <Form.Field error={this.state.courseErr}>
                                            <label>Predmet</label>
                                            <Form.Dropdown
                                                clearable
                                                selection
                                                placeholder="Odaberite predmet"
                                                value={this.state.course}
                                                onChange={this.handleInputChange}
                                                name="course"
                                                options={this.state.courseOptions}
                                                search
                                                fluid
                                            />
                                        </Form.Field>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                            <br />
                            <Button color="blue" basic="true" floated="right" onClick={this.closeAddMode}>Odustani</Button>
                            <Button
                                color="blue"
                                floated="right"
                                onClick={() => this.addCourse(this.state.course)}
                            >
                                Dodaj
                            </Button>
                        </Form>
                    </Segment>
                </Segment.Group>
            </div>);
    }
}




// WEBPACK FOOTER //
// ./src/views/StudentService/StudentOverview/AddNewCourse.js